// scroll to element
export default ({ duration = 300 }) => {
  const elOffset = 0;
  const cosParam = (window.pageYOffset - elOffset) / 2;
  let scrollCount = 0;
  let oldTimestamp = performance.now();

  const step = (newTimestamp) => {
    scrollCount += Math.PI / (duration / (newTimestamp - oldTimestamp));
    if (scrollCount >= Math.PI) window.scrollTo(0, elOffset);

    // check if we are at the top
    if (window.pageYOffset < 1) return;

    window.scrollTo(0, Math.round(cosParam + cosParam * Math.cos(scrollCount))
      + elOffset);
    oldTimestamp = newTimestamp;

    // check if we are at the top
    if (window.pageYOffset < 1) return;

    window.requestAnimationFrame(step);
  }

  window.requestAnimationFrame(step);
};
